import { useCallback } from 'react';
import List from '../../../grid.component';
import { KycStatusHandler, ProgramNameHandler } from './service';
import { useNavigate, useParams } from 'react-router-dom';
const KycGrid = () => {
    const navigate = useNavigate()
    const { id } = useParams()

    const kycDetails = useCallback((item) => () => {
        navigate(`/customer/${id}/customerKyc/details/${item?.programId}`)
    }, [navigate, id])
    const programNameHandler = useCallback((cellProps) => {
        return <ProgramNameHandler data={cellProps?.dataItem} kycDetails={kycDetails} />
    }, [kycDetails])
    const kycStatusHandler = useCallback((cellProps) => {
        return <KycStatusHandler data={cellProps?.dataItem} />
    }, [])

    const customcells = {
        "programName": programNameHandler,
        "state": kycStatusHandler
    };
    const renderCustomCell = useCallback((props, column) => {
        if (customcells[column.field]) {
            return customcells[column.field](props);
        }
    }, [customcells]);
    return (
        <div>
            <List
                pSize={5}
                className=""
                screenName={'Customer_KYC'}
                renderCustomCell={renderCustomCell}
                showDisplayColumns={false}
                url={process.env.REACT_APP_API_END_POINT + `/api/CardsActivityService/CustomerProgramsKYCK/${id}`} />
        </div>
    )
}
export default KycGrid;